import { Box, Divider, Stack } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { useContext, useState } from "react";
import { scrollbarStyle } from '../../../shared/dashboard';
// import DashboardTimeline from "../../organisms/dashboard-timeline/DashboardTimeline";
import classNames from "classnames";
import { DashboardContext } from "../../../contexts/DashboardContext";
import DashboardQueries from "../dashboard-queries/DashboardQueries";
import DashboardMetricsTimelineV2 from "../dashboard-timeline/DashboardMetricsTimelineV2";
import DashboardKeyPeople from "./DashboardKeyPeople";
import DashboardSidebar from "./DashboardSidebar";

const useStyles = makeStyles((theme) => ({
    panel: {
        height: '100%',
        width: '100%',
        minWidth: 'calc(100vw - 94px - 550px)',
        padding: 8,
        overflowX: 'hidden',
        overflowY: 'auto',
        ...scrollbarStyle,
        transition: 'all 300ms ease',
    },
    expanded: {
        height: '100%',
        width: '100%',
        minWidth: 'calc(100vw - 94px - 151px)',
        maxWidth: '100%',
    },
}));

const DashboardOverview: React.FC<{}> = () => {
    const classes = useStyles();
    const { dashboard } = useContext(DashboardContext);
    const [expanded, setExpanded] = useState<boolean>(false);

    if (!dashboard)
        return (<></>);

    return (<>
        <Stack direction="row" alignItems="flex-start" width="100%" height="100%">
            <Stack direction="column" className={classes.panel} alignItems="stretch" justifyContent="flex-start">
                <Box className={classNames(expanded && classes.expanded)}>
                    <Box mt={1} />
                    <DashboardQueries />
                    <Divider sx={{ mb: "16px !important"}}/>
                    <DashboardKeyPeople />
                    <Divider sx={{ mb: "16px !important"}}/>
                    <DashboardMetricsTimelineV2 />
                    {/* <DashboardTimeline /> */}
                </Box>
            </Stack>
            <DashboardSidebar expanded={expanded} onExpand={setExpanded} />
        </Stack>
    </>);
}

export default DashboardOverview;